import { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import Typography from './Typography';

const styles = theme => ({
  root: {
    zIndex: 1e6,
    height: theme.props.bannerHeight,
    width: '100%',
    position: 'fixed',
    top: 0,
    backgroundColor: theme.palette.common.rouge.medium,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `0 ${theme.spacing.s8}px`,
  },
  close: {
    color: 'white',
    cursor: 'pointer',
    width: theme.props.bannerHeight,
    height: theme.props.bannerHeight,
    backgroundColor: 'transparent',
    border: 'none',
  },
});

const Version = ({ classes, initiallyVisible, versionAlgo, versionApi, versionSite }) => {
  const [visible, setVisible] = useState(initiallyVisible);

  if (!visible) {
    return null;
  }

  return (
    <Typography align="center" className={classes.root} color="white" markupName="div" variant="p3">
      <div>www={versionSite}</div>
      <div>api={versionApi}</div>
      <div>algo={versionAlgo}</div>
      <button className={classes.close} onClick={() => setVisible(false)}>
        X
      </button>
    </Typography>
  );
};

Version.propTypes = {
  initiallyVisible: PropTypes.bool.isRequired,
  versionAlgo: PropTypes.string,
  versionApi: PropTypes.string,
  versionSite: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default withStyles(styles)(Version);
